import React from 'react'

import { ChakraProvider } from '@chakra-ui/react'
import { MantineProvider } from '@mantine/core'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import store from '@core/app/store/store'
import ApplyV2ErrorBoundary from '@core/components/ApplyDialogV2/ApplyV2ErrorBoundary'
import CookieConsent from '@core/components/CookieConsent/CookieConsent'
import { FilePreviewSessionProvider } from '@core/components/FilePreview'
import FilePreviewWindow from '@core/components/FilePreviewWindow'
import { IsApplyDialogProvider } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { ApplyV2ModalProvider } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { FilePreviewProvider } from '@core/utils/contexts/FilePreviewContext/FilePreviewContext'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import { generateRoutes, CustomURL } from '@core/utils/helpers/customeRouteBuilder'

import PostPageV2 from '@page/post-v2/PostPagev2'

import '@core/utils/i18n'

import '../../index.css'

import theme from '../../theme'

const urls = generateRoutes(':id', '/job/:id')

const routeCollection: object[] = []

urls.forEach((element: CustomURL) => {
    routeCollection.push({
        path: element.url,
        element: (
            <ThemeProvider>
                <IsApplyDialogProvider>
                    <ApplyV2ErrorBoundary>
                        <ApplyV2ModalProvider>
                            <PostPageV2 />
                            <CookieConsent />
                        </ApplyV2ModalProvider>
                    </ApplyV2ErrorBoundary>
                </IsApplyDialogProvider>
            </ThemeProvider>
        ),
    })
})

const router = createBrowserRouter(routeCollection)

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <MantineProvider>
                    <ModalProvider>
                        <FilePreviewProvider>
                            <FilePreviewSessionProvider>
                                <RouterProvider router={router} />
                                <FilePreviewWindow />
                            </FilePreviewSessionProvider>
                        </FilePreviewProvider>
                    </ModalProvider>
                </MantineProvider>
            </ChakraProvider>
        </Provider>
    </>
)
